module.exports = __webpack_public_path__ + "static/media/areas04M.451c7c62.jpg";